import { EuiFlexGroup, EuiFlexItem, EuiIcon } from '@elastic/eui';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import APIV1 from '../../../api/axios/APIV1';
import Tooltip from '../../../components/Global/Tooltip/Tooltip';
import { userHasPermission } from '../../../helper/auth';
import { SET_EDIT_OUTLET } from '../../../reduxStore/types/outlet';
import { toastsErrorMessage, toastSuccessMessage } from '../../../utils/toasts';

const SubscriptionActions = ({ subscription, onRefresh }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const permissions = useSelector((state) => state.permission.permission);
    const [showToolTip, setShowToolTip] = useState({
        edit: false,
        delete: false,
    });

    const handleEditController = useCallback(
        (id) => {
            dispatch({
                type: SET_EDIT_OUTLET,
                payload: {
                    editOutlet: true,
                },
            });
            history.push(`/subscription/edit/${id}`);
        },
        [dispatch, history]
    );

    const handleDeleteController = useCallback(
        async (id) => {
            if (window.confirm('Are you sure you want to delete this outlet?')) {
                try {
                    const response = await APIV1.delete(`/subscription-requests/${id}`);
                    if (response && response.success) {
                        toastSuccessMessage('Outlet deleted successfully', dispatch);
                        if (onRefresh) onRefresh();
                    } else {
                        toastsErrorMessage('Error deleting outlet', dispatch);
                    }
                } catch (error) {
                    toastsErrorMessage('Error deleting outlet', dispatch);
                }
            }
        },
        [dispatch, onRefresh]
    );

    return (
        <EuiFlexGroup
            direction='row'
            style={{ position: 'relative' }}
            gutterSize='s'
            justifyContent='flexEnd'
            alignItems='center'
            wrap={false}
            responsive={false}
        >
            <EuiFlexItem grow={false}>
                {userHasPermission(permissions, '/subscription', 'write') && (
                    <>
                        <EuiIcon
                            type='documentEdit'
                            size='original'
                            color='primary'
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleEditController(subscription.id)}
                            onMouseOver={() =>
                                setShowToolTip((prevState) => ({
                                    ...prevState,
                                    edit: true,
                                }))
                            }
                            onMouseOut={() =>
                                setShowToolTip((prevState) => ({
                                    ...prevState,
                                    edit: false,
                                }))
                            }
                        />
                        {showToolTip.edit && <Tooltip content={'Edit subscription'} />}
                    </>
                )}
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
                {userHasPermission(permissions, '/subscription', 'delete') && (
                    <>
                        <EuiIcon
                            type='trash'
                            size='original'
                            color='danger'
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleDeleteController(subscription.id)}
                            onMouseOver={() =>
                                setShowToolTip((prevState) => ({
                                    ...prevState,
                                    delete: true,
                                }))
                            }
                            onMouseOut={() =>
                                setShowToolTip((prevState) => ({
                                    ...prevState,
                                    delete: false,
                                }))
                            }
                        />
                        {showToolTip.delete && <Tooltip content={'Delete subscription'} />}
                    </>
                )}
            </EuiFlexItem>
        </EuiFlexGroup>
    );
};

export default React.memo(SubscriptionActions);
